import type { FunctionComponent } from "react";

import iconJson from "./icon-listening-final.json";
import { StyledIconHeadphoneSvg, StyledPlayer } from "./styles";

type Props = {
  isPlayed: boolean;
};
export const HeadphoneIcon: FunctionComponent<Props> = ({ isPlayed }) =>
  isPlayed ? <StyledPlayer src={iconJson} autoplay loop /> : <StyledIconHeadphoneSvg />;

HeadphoneIcon.displayName = "HeadphoneIcon";
